export default __webpack_public_path__ + "assets/front/scss/recherche/astuces/styles.6319162f11364a7b6c713ba1bd9c5cd5.css";